import React from 'react';

import { Icon } from '@column/column-ui-kit';
import { Badge } from '@column/ui';

import { TransferEntryType } from '~/repositories';

import { getTransferBadgeClassName } from './utils';

export enum TransferDirection {
  Incoming = 'Incoming',
  Outgoing = 'Outgoing',
  Internal = 'Internal',
}

export const getTransferDirection = (transferType: TransferEntryType, isIncoming: boolean): TransferDirection => {
  switch (transferType) {
    case 'ach_batch':
    case 'check_batch':
    case 'book':
      return TransferDirection.Internal;
    case 'check_credit':
      return TransferDirection.Incoming;
    case 'check_debit':
      return TransferDirection.Outgoing;
    default:
      return isIncoming ? TransferDirection.Incoming : TransferDirection.Outgoing;
  }
};

export const getTransferDirectionLabel = (transferType: TransferEntryType, isIncoming: boolean): string => {
  if (transferType === 'ach_batch' || transferType === 'check_batch') {
    return 'Batch';
  }
  if (transferType === 'check_credit') {
    return 'Deposit';
  }
  if (transferType === 'check_debit') {
    return 'Issue';
  }
  return getTransferDirection(transferType, isIncoming);
};

export const getTransferDirectionIcon = (transferType: TransferEntryType, isIncoming: boolean) => {
  const direction = getTransferDirection(transferType, isIncoming);
  switch (direction) {
    case TransferDirection.Incoming:
      return <Icon.CircleArrowDown />;
    case TransferDirection.Outgoing:
      return <Icon.CircleArrowUp />;
    case TransferDirection.Internal:
      return <Icon.Swap />;
  }
};

interface TransferDirectionBadgeProps {
  type: TransferEntryType;
  isIncoming: boolean;
}

export const TransferDirectionBadge: React.FC<TransferDirectionBadgeProps> = ({ type, isIncoming }) => (
  <Badge variant="ghost" className={getTransferBadgeClassName()}>
    {getTransferDirectionIcon(type, isIncoming)}
    {getTransferDirectionLabel(type, isIncoming)}
  </Badge>
);
